import createNewCharacterCountEntry from '../helpers/createNewCharacterCountEntry'
import trackCountChanges from '../helpers/trackCountChanges.js'
import createTempId from '@/helpers/createTempId'
//-------------------
// process add count
//-------------------
export default function processAddCount({
  parms = {},
  changed_counts = [],
  original_counts = [],
  character = null,
} = {}) {
  console.log('--------------------------------------')
  console.log('IN processAddCount parms = ', parms)
  //-----------
  // get parms
  //-----------
  // Support both { payload: {...} } and a flat payload (e.g. { name: 'Xxx' })
  const payload = parms.payload ?? parms ?? {}

  const id = payload.id ?? createTempId() // temp id for tracking until saved to db and gets real id
  payload.id = id // ensure temp id is in payload for tracking

  const track_count = payload // includes temp id for tracking
  const name = payload.name ?? 'Unnamed Count'
  const value = payload.value ?? 0 // default to 0 on add; value changes are treated as updates

  const character_id = character?.id ?? null

  console.log('count character_id = ', character_id)
  console.log('COUNT TO ADD = ', track_count)
  //-------------------------------
  // update tracking with new count
  //-------------------------------
  console.log('2. off to track count changes')
  changed_counts = trackCountChanges({
    count: track_count,
    original_counts,
    changed_counts,
    character_id,
  })
  //---------------------------------
  // create new character count entry
  //---------------------------------
  console.log('3. off to create new character count entry')
  let new_count = createNewCharacterCountEntry({
    id: track_count.id, // temp id used for tracking
    name: name,
    value: value,
    character: character,
  })
  console.log('character.counts = ', character.counts)
  //-----------------------------
  // add count to character counts
  //-----------------------------
  character.counts.push(new_count)
  console.log('NEW COUNT ADDED TO CHARACTER = ', new_count)
  //------------------------
  // return mutated objects
  //------------------------
  console.log('completed processAddCount new count = ', new_count)
  return { changed_counts, new_count, character }
}
